import React, {FC, useEffect, useState} from 'react';
import HLModal from "../../shared/components/modal/HLModal";
import HLInfoRow from "../../shared/components/info-row/HLInfoRow";
import {getEnabledStudentsCountFetch} from "../../app/axios/studentFetches";

interface StudentsStatsModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
}

const StudentsStatsModal: FC<StudentsStatsModalProps> = (
    {
        open,
        setOpen
    }) => {
    const [enabledStudentsCount, setEnabledStudentsCount] = useState<number>(0);

    useEffect(() => {
        if (open) loadStats();
    }, [open]);

    const loadStats = () => getEnabledStudentsCountFetch()
        .then(count => setEnabledStudentsCount(count));

    const closeModal = () => {
        setOpen(false)
    };

    return (
        <HLModal open={open} onClose={closeModal} title="Статистика">
            <HLInfoRow
                label="Количество учеников:"
                value={enabledStudentsCount}
            />
        </HLModal>
    );
};

export default StudentsStatsModal;


